import React from 'react';
import ReportDrilldownPage from './ReportDrilldownPage';

const OwnerDrilldownReport = () => <ReportDrilldownPage type="owner" />;

export default OwnerDrilldownReport;
